// Spanish translation

const es = {
  "menu.hotel_booking": "Reservas New",
  "hotel.booking.number": "Número",
  "hotel.booking.party": "Titular",
  "hotel.booking.contact": "Contacto",
  "hotel.booking.bill_to": "Facturar a",
  "hotel.booking.bill.all": "Todo",
  "hotel.booking.bill.partial": "Parcial",
  "hotel.booking.booking_date": "Fecha de Reserva",
  "hotel.booking.total_amount": "Importe",
  "hotel.booking.total_advances": "Total Anticipos",
  "hotel.booking.lines": "No. Hab",
  "hotel.booking.media": "Medio",
  "hotel.booking.travel_cause": "Motivo de Viaje",
  "hotel.booking.meal_plan": "Regimen Comida",
  "hotel.booking.space": "Espacio",
  "hotel.booking.price_list": "Lista de Precios",
  "hotel.booking.payment_term": "Plazo de Pago",
  "hotel.booking.rate_plan": "Plan Tarifario",
  "hotel.booking.pending_to_pay": "Pendiente de Pago",
  "hotel.booking.group": "Grupo",
  "hotel.booking.corporative": "Corporativo",
  "hotel.booking.state": "Estado",
  "hotel.booking.offer": "Oferta",
  "hotel.booking.complimentary": "Complimentary",
  "hotel.booking.type_complimentary": "Tipo Complimentary",
  "hotel.booking.in_house": "En Casa",
  "hotel.booking.courtesy": "Cortesía",
  "hotel.booking.confirm": "Confirmar",
  "hotel.booking.cancel": "Cancelar",
  "hotel.booking.no_show": "No Presentado",
  "hotel.booking.block": "Bloquear",
  "hotel.booking.finished": "Terminado",
  "hotel.booking": "RESERVA",
  "hotel.booking.today": "Hoy",
  "hotel.booking.confirmed": "Confirmada",
  "hotel.booking.bill": "Facturar",
  "hotel.booking.channel": "Canal",
  "hotel.booking.ota_booking_code": "Cod. OTA",
  "hotel.booking.agent": "Agente",
  "hotel.booking.notes": "Notas",
  "hotel.booking.advances_payments": "Anticipos/Pagos",
  "hotel.booking.invoices": "Facturas",
  "hotel.booking.notifications": "Notificaciones",
  "hotel.booking.pax": "PAX",
  "hotel.booking.taxes_exception": "Excepción de IVA",
  "hotel.booking.payments": "Payments",
  "hotel.booking.holder": "Titular",
  "hotel.booking.holder_guest": "Titular / Huesped",
  "hotel.booking.guest": "Huesped",
  "hotel.booking.blocked": "Bloqueo",
  "hotel.booking.report": "Reserva",
  "hotel.booking_statement.report": "Pre-Cuenta",
  "hotel.folio": "FOLIO",
  "hotel.booking.lead_origin": "Origen",
  "hotel.folio.overbooking": "Sobreventa",
  "hotel.folio.accept": "Aceptar",
  "hotel.booking.add_rooms": "Agregar Habitación",
  "hotel.booking.add_rooms.accept": "Aceptar",
  "hotel.booking_statement": "PRE-CUENTA",
  "hotel.booking.plan+rate": "Plan + Tarifas sin impuestos",
  "hotel.booking.fees_taxes_not_included": "CARGOS E IMPUESTOS NO INCLUIDOS",
  "hotel.booking.msg_iva_foreign":
    "Impuesto IVA no incluido a extranjeros, previa verificación de pasaporte y tarjeta migratoria al momento del check-in.",
  "hotel.booking.msg_iva": "IVA incluido del 19%.",
  "hotel.booking.i_foreigner": "Soy Extranjero",
  "hotel.booking.i_colombiano": "Soy Colombiano",
  "hotel.booking.add_rooms.selector.product": "Categoria",
  "hotel.booking.add_rooms.selector.unit_price_w_tax": "Tarifa",
  "hotel.booking.add_rooms.selector.available": "Disponibles",
  "hotel.booking.add_rooms.selector.adults": "Adultos",
  "hotel.booking.add_rooms.selector.children": "Niños",
  "hotel.booking.add_rooms.selector.room": "Hab.",
  "hotel.booking.add_rooms.selector.add": "Agregar",
  "hotel.booking.add_rooms.selector.unit_price": "Precio",
  "hotel.booking.add_rooms.selector.sale_price_taxed": "Precio + IVA",
  "hotel.booking.add_rooms.selector.discount": "Desc.",
  "hotel.booking.add_rooms.nights_quantity": "Noches",
  "hotel.booking.add_payment": "Anticipo / Pago",
  "hotel.booking.add_payment.amount": "Valor",
  "hotel.booking.add_payment.voucher": "Voucher",
  "hotel.booking.add_payment.statement": "Medio de Pago",
  "hotel.booking.add_payment.pay": "Pagar",
  "hotel.booking.add_room.arrival_date": "Llegada",
  "hotel.booking.add_room.departure_date": "Partida",
  "hotel.booking.add_room.nights_quantity": "Noches",
  "hotel.booking.add_rooms.selector.rooms": "Hab.",
  "hotel.chart.occupation_room": "Ocupación de Habitaciones",
  "hotel.chart.occupation_today": "Occ. Hoy",
  "hotel.chart.occupation_tomorrow": "Occ. Mañana",
  "hotel.chart.check_in_today": "Check-In Today",
  "hotel.chart.check_out_today": "Check-Out Today",
  "hotel.chart.occupation_rate": "Occupation Rate",
  "hotel.chart.occupation_rate_today": "Today",
  "hotel.chart.occupation_rate_tomorrow": "Mañana",
  "hotel.booking.bill.party": "Tercero",
  "hotel.booking.bill.kind": "Clase",
  "hotel.booking.bill.bill": "Facturar",
  "hotel.booking.bill.add_guest": "Agregar Huesped",
  "hotel.booking.bill.add_vehicle_plate": "Agregar Placa",
  "hotel.booking.wiz_payment.voucher": "Voucher",
  "hotel.booking.wiz_payment.statement": "Medio de Pago",
  "hotel.booking.wiz_payment.amount": "Importe",
  "hotel.booking.wiz_payment.notes": "Notes",
  "booking.widget_side.today": "Hoy",
  "booking.widget_side.tomorrow": "Mañana",
  "booking.widget_side_status.revenue_today": "Ingresos Día",
  "hotel.booking.wiz_payment.button_pay": "Pay",
  "hotel.booking.undefined": "Indefinido",
  "hotel.booking.environment": "Ambiente",
  "hotel.booking.update_taxes": "Actualizar Impuestos",
  "hotel.booking.update_taxes.start.accept": "Aceptar",
  "hotel.booking.update_taxes.start.taxes": "Impuestos",
  "hotel.booking.apply_taxes_exception": "Excepción IVA",
  "hotel.booking.add_rooms.selector.accommodation": "Acomodación",
  "hotel.booking.add_rooms.selector.availability": "Disponibilidad",
  "hotel.booking.wizard_update_taxes": "Actualizar Impuestos",
  "hotel.charge.tax": "Impuesto",
  "hotel.booking.wizard_payment_correct": "Agregado correctamente",

};

export default es;
